import capaPrey from "../../img/productions/capaPrey.jpeg"
import capaOnlyMurders from "../../img/productions/capaOnlyMurders.jpeg"
import capaWWDITS from "../../img/productions/capaWWDITS.jpg"
import capaGoodBurger from "../../img/productions/capaGoodBurder.jpg"
import capaAtlanta from "../../img/productions/capaAtlanta.jpg"
import capaPose from "../../img/productions/capaPose.jpg"
import capaTrust from "../../img/productions/capaTrust.jpg"
import capaMayans from "../../img/productions/capamayans.jpg"
import capaFirstRefor from "../../img/productions/capaFirstRefor.jpg"


const imgDubbing = [
    {
        id: 1,
        name: "Prey",
        alt: "poster Prey",
        img: capaPrey,
    },
    {
        id: 2,
        name: "Only Murders",
        alt: "poster Only Murders In The Building",
        img: capaOnlyMurders,
    },
    {
        id: 3,
        name: "What We Do In The Shadows",
        atl: "poster What We Do In The Shadows",
        img: capaWWDITS,
    },
    {
        id: 4,
        name: "Good Burger 2",
        alt: "poster Good Burger 2",
        img: capaGoodBurger,
    },
    {
        id: 5,
        name: "Atlanta",
        alt: "poster Atlanta",
        img: capaAtlanta,
    },
    {
        id: 6,
        name: "Pose",
        alt: "poster Pose",
        img: capaPose,
    },
    {
        id: 7,
        name: "Trust",
        alt: "poster Trust",
        img: capaTrust,
    },
    
    {
        id: 9,
        name: "Mayans",
        alt: "poster Mayans",
        img: capaMayans,
    },
    {
        id: 10,
        name: "First Reformed",
        alt: "poster First Reformed",
        img: capaFirstRefor,
    },

]

export default imgDubbing